import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Restores ZIP export statuses from sessionStorage on page load.
// Follows the same pattern as report_restoration_controller.js.
export default class extends Controller {
  connect() {
    this.restoreActiveExports()
  }

  async restoreActiveExports() {
    const activeExports = JSON.parse(sessionStorage.getItem('activeZipExports') || '[]')

    if (activeExports.length === 0) return

    try {
      const response = await fetch('/zip_export_caches/active', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ zip_export_cache_ids: activeExports })
      })

      if (!response.ok) {
        logger.log('ZipExport restoration: Failed to fetch active exports')
        return
      }

      const data = await response.json()

      if (data.exports && data.exports.length > 0) {
        this.renderExportStatuses(data.exports)
      }

      // Clean up sessionStorage for exports that no longer exist on server
      const serverIds = (data.exports || []).map(e => e.id)
      const cleaned = activeExports.filter(id => serverIds.includes(id))
      sessionStorage.setItem('activeZipExports', JSON.stringify(cleaned))
    } catch (error) {
      logger.log('ZipExport restoration: Error:', error)
    }
  }

  renderExportStatuses(exports) {
    let container = document.getElementById('reportStatuses')

    if (!container) {
      container = document.createElement('div')
      container.id = 'reportStatuses'
      container.className = 'sidebar-aware'

      const bodyElement = document.body
      const hasSidebarController = bodyElement.dataset.controller?.includes('sidebar')
      if (hasSidebarController) {
        const sidebarCollapsed = bodyElement.dataset.sidebarCollapsedValue === 'true'
        if (sidebarCollapsed) {
          container.classList.add('sidebar-collapsed')
        }
      }

      document.body.appendChild(container)
      container.offsetHeight
    }

    exports.forEach((exp) => {
      if (document.querySelector(`[data-zip-export-cache-id-value="${exp.id}"]`)) return
      container.insertAdjacentHTML('beforeend', exp.html)
    })

    function updateReportStatusOverlayHeight() {
      const c = document.getElementById('reportStatuses')
      if (c && c.classList.contains('show')) {
        requestAnimationFrame(() => {
          const height = c.offsetHeight
          document.documentElement.style.setProperty('--report-status-overlay-height', height + 'px')
        })
      } else {
        document.documentElement.style.setProperty('--report-status-overlay-height', '0px')
      }
    }

    window.updateReportStatusOverlayHeight = updateReportStatusOverlayHeight

    setTimeout(() => {
      container.classList.add('show')
      setTimeout(() => updateReportStatusOverlayHeight(), 50)
    }, 1)
  }
}
